import gql from 'graphql-tag';
import actionTypes from './constants';

/* */
export const getClient = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_CLIENT}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.PA_getClient);

/* */
export const searchMoves = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.SEARCH_MOVES}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.PA_searchMoves);

/* */
export const getProducts = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_PRODUCTS}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.PA_getProducts);

/* */
export const getEndpoints = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_ENDPOINTS}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.PA_getEndpoints);

/* */
export const searchOperations = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.SEARCH_OPERATIONS}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data.PA_searchOperations);

/* */
export const createOperation = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.CREATE_OPERATION}`,
  variables,
})
  .then(({ data }) => data.PA_createOperation);

/* */
export const getRefillStatus = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_REFILL_STATUS}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data)
  .then((data) => ({ refillStatus: data.PA_getRefillStatus }));

/* */
export const getRefillStatusByToken = (client, variables, fetchPolicy = 'no-cache') => client.query({
  query: gql`${actionTypes.gql.GET_REFILL_STATUS_BY_TOKEN}`,
  fetchPolicy,
  variables,
})
  .then(({ data }) => data)
  .then((data) => ({ refillStatus: data.PA_getRefillStatusByToken }));

/* */
export const setRefillStatus = (client, variables) => client.mutate({
  mutation: gql`${actionTypes.gql.SET_REFILL_STATUS}`,
  variables,
})
  .then(({ data }) => data)
  .then((data) => data.PA_setRefillStatus);
